class Exporter {
    static handleExport(data, filename = 'export.csv') {
        if (!data || data.length === 0) return;

        try {
            const csvRows = [];

            const headers = Object.keys(data[0]);
            csvRows.push(headers.join(','));

            data.forEach(row => {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"');
                    return `"${escaped}"`;
                });
                csvRows.push(values.join(','));
            });

            const csvContent = csvRows.join('\n');
            const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
        }
    };
}

export default Exporter;